import { SectionReviewState } from "generated/graphql";

export const REVIEW_STATE_UI = {
  [SectionReviewState.Complete]: {
    color: "bg-secondary-50",
    name: "Complete",
    movableStates: [SectionReviewState.Review, SectionReviewState.Validation],
  },
  [SectionReviewState.Review]: {
    color: "bg-gray-50",
    name: "Review",
    movableStates: [SectionReviewState.Validation, SectionReviewState.Complete],
  },
  [SectionReviewState.Validation]: {
    color: "bg-peri-50",
    name: "QA",
    movableStates: [SectionReviewState.Review, SectionReviewState.Complete],
  },
} as const;
